<template>
  <el-container class="list_main_content">
    <el-aside width="200px" v-show="asideShow">
      <p class="flow_tree_top_title">新建流程分类</p>
      <FlowTree ref="FlowTree" @currentTree="getCurrent" :loadCount="loadCount"></FlowTree>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{'navbar-collapse-right':!asideShow}"
      :style="navbarCollapseStyle"
      @click="asideShow=!asideShow"
    >
      <div class="navbar-collapse-bg" style="display: none;">
        <i
          class="navbar-collapse-arrow"
          :class="{'el-icon-arrow-left':asideShow,'el-icon-arrow-right':!asideShow}"
        ></i>
      </div>
    </div>
    <el-container style="border-left:1px solid #E7EAEC" :style="conheight">
      <h3 class="flow_table_title">新建流程列表</h3>
      <collapse-search>
      <div class="content_top_wrap">
        <el-input
          size="small"
          clearable
          style="width:240px;"
          placeholder="流程名称"
          prefix-icon="el-icon-search"
          v-model="tableData"
          @keyup.enter.native="searchEnterFun">
        </el-input>
        <div class="date_wrap">
          <p>到达时间</p>
          <el-date-picker
            v-model="date"
            type="datetimerange"
            align="right"
            size="small"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </div>
        <el-row>
          <el-col :span="24">
            <el-button
              style="margin-left: 10px"
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="search('find')"
              >查询</el-button
            >
            <el-button size="small" @click="reset" icon="el-icon-refresh"
              >重置</el-button
            >
          </el-col>
        </el-row>
      </div>
      </collapse-search>
      <el-main class="flow_list_content">
        <!-- default-sort  排序 -->
        <el-table
          :data="rows"
          header-cell-class-name="flowList-header-row"
          row-class-name="flowList-row"
          size="medium"
          height="100%"
          border
          style="width: 100%;"
          v-loading.fullscreen.lock="fullscreenLoading"
          :default-sort="{prop: 'createTime', order: 'descending'}"
        >
          <el-table-column type="index" width="40" align="center" label="序号"></el-table-column>
          <el-table-column label="流程名称" show-overflow-tooltip align="center" width="350">
            <template slot-scope="scope">
              <span class="flowList-subject" @click="handleRowClick(scope.row)">{{scope.row.name}}</span>
            </template>
          </el-table-column>>
          <el-table-column prop="defKey" label="流程key" align="center" width="170"></el-table-column>
          <el-table-column prop="desc" label="流程描述" align="center" ></el-table-column>
          <el-table-column label="创建时间" show-overflow-tooltip align="center" width="135">
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | dateformat('yyyy-MM-dd HH:mm:ss')}}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer height="45px">
        <el-row type="flex" justify="end">
          <el-pagination
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pagination.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </el-row>
      </el-footer>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import FlowTree from "@/components/flow/flowTree.vue";
import utils from "@/utils.js";
import process from "@/api/process.js";

export default {
  name: "flowList",
  components: {
    FlowTree,
  },
  data() {
    return {
      asideShow: false,
      tableData: "",
      date: "",
      currentTree: "",
      fullscreenLoading: true,
      checkBoxData: [],
      conheight:{ height:'' },
    };
  },
  computed: mapState({
    navbarCollapseStyle: function () {
      if (this.asideShow) {
        return { left: "200px" };
      }
      return { left: "0px" };
    },
    rows: (state) => state.storeProcess.rows,
    pagination: (state) => state.storeProcess.pagination,
    total: (state) => state.storeProcess.total,
  }),
  methods: {
     getHeight(){
      this.conheight.height=window.innerHeight-80+'px';
    },
   
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("storeProcess/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function (currentPage) {
      //点击第几页
      this.$store.dispatch("storeProcess/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function (e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
    // 查询
    search(str) {
      this.openFullScreen();
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let querys = []; //查询条件
      let queryFilter = {};
      let pageBean = { pageBean: this.pagination };
      let beginDate = ""; //开始时间
      let endDate = ""; //结束时间
      let group = "main"; //判断条件
      if (this.tableData == "" && (this.date == "" || this.date == null)) {
        if (this.currentTree != "") {
          querys = [
            {
              property: "type_id_",
              value: this.currentTree,
              group: "typeId",
              operation: "IN",
              relation: "AND"
            }
          ];
        }
      } else {
        if (this.currentTree) {
          querys = [
            {
              property: "type_id_",
              value: this.currentTree,
              group: "typeId",
              operation: "IN",
              relation: "AND"
            },
            {
              property: "name",
              value: this.tableData,
              group: "main",
              operation: "LIKE",
              relation: "OR"
            }
          ];
        } else {
          querys = [
            {
              property: "name_",
              value: this.tableData,
              group: "main",
              operation: "LIKE",
              relation: "OR"
            }
          ];
        }
      }
      if (this.tableData && this.date) {
        group = "time";
      }

      if (this.date) {
        beginDate = utils.formatDate(this.date[0].getTime());
        endDate = utils.formatDate(this.date[1].getTime());
        querys.push({
          property: "create_time_",
          value: [beginDate, endDate],
          group: group,
          operation: "BETWEEN",
          relation: "AND"
        });
      }
      queryFilter = { pageBean: this.pagination, querys };
      this.$store
        .dispatch("storeProcess/getFlowListByPagination", queryFilter)
        .then(() => {
          this.fullscreenLoading = false;
        });
    },
    //重置
    reset() {
      this.tableData = "";
      this.date = "";
      this.search("find");
    },

    handleRowClick(row) {
      let token = this.$store.state.login.currentUser.token;
      let url = window.context.front;
      if (!row.leaders || row.leaders.length == 0) {
        //this.$router.push("/agentStart/" + row.id + "/0");
        url = url + "/agentStart/" + row.id + "/0";
      } else {
        let html =
          "<select ref=" +
          Math.random() +
          ' id="approvalLeaderSelect" style="width: 200px;height: 30px;border-radius: 4px;margin: 20px 70px;" ><option value="">请选择</option>';
        row.leaders.forEach((identity) => {
          html +=
            '<option value="' +
            identity.id +
            '">' +
            identity.name +
            "</option>";
        });
        html += "</select>";
        let this_ = this;
        this.$alert(html, "选择发起人", {
          dangerouslyUseHTMLString: true,
          beforeClose: function(action, instance, done) {
            if (action == "confirm") {
              let se = document.getElementById("approvalLeaderSelect");
              if (se.selectedIndex == 0) {
                this.$message.warning("请选择一个发起人");
              } else {
                instance.close();
                /*this_.$router.push (
                  "/agentStart/" + row.id + "/" + se[se.selectedIndex].value
                );*/
                url =
                  url +
                  "/agentStart/" +
                  row.id +
                  "/" +
                  se[se.selectedIndex].value;
              }
            } else {
              instance.close();
            }
          }
        });
      }
      url = url + "?token=" + token;
      window.open(url,'启动流程','height='+(screen.availHeight-70)+',width='+(screen.availWidth-10));
      // window.open(url,"_blank","width="+(window.screen.availWidth-10)+",height="+(window.screen.availHeight-70));
    },
    //子组件传值父组件(新建流程分类查询)
    getCurrent(data) {
      if (data.id == 6) {
        this.openFullScreen();
        let pageBean = { pageBean: this.pagination };
        this.$store
          .dispatch("storeProcess/getFlowListByPagination", pageBean)
          .then(() => {
            this.fullscreenLoading = false;
          });
      } else {
        let ids = [];
        this.getFlowTrees(data, ids);
        this.currentTree = ids.join(",");
        this.search("find");
      }
    },
    getFlowTrees(data, ids) {
      ids.push(data.id);
      let arr = data.children;
      for (var i = 0; i < arr.length; i++) {
        this.getFlowTrees(arr[i], ids);
      }
    },
    loadCount() {
      let pageBean = {};
      return process.getNewProcessCount(pageBean);
    }
  },
  created() {
    //页面高度设置
    window.addEventListener("resize",this.getHeight);
    this.getHeight();
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" }
    }; //初次加载默认pageBean
    this.$store
      .dispatch("storeProcess/getFlowListByPagination", pageBean)
      .then(() => {
        //页面加载调用tudo.js里面的分页方法
        this.fullscreenLoading = false;
      });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";
.el-table /deep/ th.done-header-row {
  background-color: #fafafa;
  font-size: 12px;
}
/deep/.el-table .cell {
  padding-left: 0px;
  padding-right: 0px;
}
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 12px !important;
}
.el-table /deep/ tr.todo-row {
  font-size: 12px;
  color: $--color-text-regular;
}
/deep/.el-table--border th,
/deep/.el-table--border td {
  border-right: 1px dashed #ebeef5;
}

.el-container {
  background-color: #fff;
}

.el-row {
  margin-bottom: 10px;
}

.el-header {
  border-bottom: 1.5px solid #ededed;
}

.flowList-subject {
  cursor: pointer;
}

.flowList-subject {
  color: $--theme-color;
}
/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}
.top-title {
  line-height: 58px;
  margin-left: 20px;
  font-size: 16px;
  color: #a2a2a2;
}

/deep/.el-tree {
  position: relative;
  cursor: default;
  background: #fff;
  color: $--color-text-primary;
  font-size: 13px;
}
/deep/.el-pagination {
  text-align: justify;
  margin: 0 auto;
  font-family: "微软雅黑", "宋体", Arial, sans-serif !important;
  font-size: 12px !important;
}
/deep/.pagination {
  margin-left: 0px;
  margin-top: 10px;
  text-align: left;
  font-family: "微软雅黑", "宋体", Arial, sans-serif;
  font-size: 12px !important;
}
.flow_list_content {
  padding: 0 20px 20px 20px;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  margin: 10px 0 0 20px;
  /deep/ .el-input__prefix,
  /deep/.el-input__suffix {
    height: 32px;
  }
  /deep/.el-date-editor--datetimerange.el-input__inner {
    width: 240px;
  }
  .date_wrap {
    display: flex;
    p {
      width: 54px;
      margin: 8px;
    }
  }
}
</style>
